import clsx from 'clsx'
import React, { FunctionComponent, ReactNode, useContext } from 'react'

import { useThemeClass } from '../Theme'
import { AccordionContext } from './AccordionContext'
import { ACCORDION_DETAILS_DISPLAY_NAME } from './constants'
import styles from './style.module.scss'
import { useInertSupport } from './useInertSupport'

export interface AccordionDetailsProps {
  children: ReactNode
}

export const AccordionDetails: FunctionComponent<AccordionDetailsProps> = ({ children }) => {
  const { id, expanded, testNameSpace, animated } = useContext(AccordionContext)
  const themeClass = useThemeClass()
  const supportsInert = useInertSupport()
  const detailsClassNames = clsx(styles.details, expanded && styles.detailsExpanded, animated && styles.detailsAnimated)
  const detailsContainerClassNames = clsx(styles.detailsContainer, styles[themeClass])

  const detailsDataTestId = { 'data-testid': `${testNameSpace}-panel` }
  const detailsContainerDataTestId = { 'data-testid': `${testNameSpace}-panel-container` }

  return (
    <div
      role='region'
      id={`${id}-panel`}
      className={detailsClassNames}
      {...(testNameSpace.length > 0 && detailsDataTestId)}
      aria-labelledby={id}
      aria-hidden={!expanded}
      {...(supportsInert && !expanded && { inert: '' })}
    >
      <div {...(testNameSpace.length > 0 && detailsContainerDataTestId)} className={detailsContainerClassNames}>
        {children}
      </div>
    </div>
  )
}

AccordionDetails.displayName = ACCORDION_DETAILS_DISPLAY_NAME
